import WordFinder from "../components/WordFinder";

export default function WordFinderPage() {
  return <WordFinder />;
}
